import React, {FC} from 'react';

import {TextProps} from '@/components/Text';
import TransparentButton from '@/components/TransparentButton';
import {useThemedStyles} from '@/theme';

import {styles} from './AddWalletButton.style';

interface IProps {
  onPress: () => void;
  text?: TextProps;
}

const AddWalletButton: FC<IProps> = ({onPress, text}) => {
  const style = useThemedStyles(styles);

  return (
    <TransparentButton
      onPress={onPress}
      rippleDisabled
      style={style.button}
      text={{
        id: 'wallets.linkNewWallet',
        ...text,
      }}
    />
  );
};

export default AddWalletButton;
